<template>
    <v-container fluid>
        <v-card class="elevation-3" :loading="loading">
            <!-- Loading Overlay -->
            <v-overlay :value="loading" absolute z-index="999">
                <div class="text-center">
                    <v-progress-circular
                        indeterminate
                        size="70"
                        width="7"
                        color="secondary"
                    ></v-progress-circular>
                    <div class="mt-4 white--text" style="font-size: 18px;">
                        {{ $t('LoadingResults') || 'Loading Results...' }}
                    </div>
                </div>
            </v-overlay>

            <div class="card-title">
                {{ $t('SurveyResults') }}
            </div>
            <v-spacer />
            <router-link :to="{ name: 'my-submissions'}" custom>
                <v-btn fab small class="white--text float-end" color="secondary" role="link" style="margin:14px;">
                    <v-icon>mdi-arrow-left-circle</v-icon>
                </v-btn>
            </router-link>
            <v-card-text v-if="results.length > 0">
                <h2> {{title}}</h2>
                <GridWithServerPaging :headers="headers" :items="results" :total="totalCount" disable-sort class="mt-4" @onChange="listSurveyresults">
                    <template v-slot:[`item.user`]="{ item }">
                        <b class="primary--text">{{ item.user }}</b>
                    </template>
                </GridWithServerPaging>
            </v-card-text>
            <v-card-text v-else class="text-center">
                <span>{{ $t('NoItemsToShow') }}</span>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import SurveyService from '@/services/SurveyService'
    import GridWithServerPaging from '@/components/controls/GridWithServerPaging.vue'


    export default {
        components: {
            GridWithServerPaging
        },

        data() {
            return {
                loading: false,
                surveyResult: null,
                options: {
                    page: 1,
                    itemsPerPage: 20
                },
                totalCount: 10,
                headers: [],
                results: [],
                title: ''
            }
        },

        created() {
            this.listSurveyresults()
        },

        methods: {

            listSurveyresults(options) {

                if (this.$route.params.id) {
                    this.loading = true
                    const page = options != undefined || options == false ? options.page : 1
                    const pageSize = options != undefined ? options.itemsPerPage : 10
                    SurveyService.listSurveyMyResults(this.$route.params.id, page, pageSize).then(res => {
                        if (res.data) {
                            this.headers = []
                            this.results = []
                            this.title = res.data.title
                            this.totalCount = res.data.totalCount
                            this.headers = res.data.questions.map(x => ({ text: x.name, value: `q${x.id}` }))
                            this.headers.splice(0, 0, { text: this.$t('Username'), value: 'user' })
                            for (var i = 0; i < res.data.surveyParticipants.length; i++) {
                                const obj = {}
                                let item = res.data.surveyParticipants[i]
                                for (var j = 0; j < item.items.length; j++) {
                                    let subItem = item.items[j].result
                                    let ref = `q${subItem.questionId}`
                                    obj[ref] = subItem.answer
                                }
                                obj.user = `${item.fullName || item.sourceIp}`
                                this.results.push(obj)
                            }

                        }
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            }
        },
    }
</script>

<style scoped>
    .odd { background: #fff !important }
    .custom-table { border-collapse: collapse; width: 100%; }
        .custom-table thead th { border: 1px solid #ccc; color: #fff !important; font-weight: normal !important; font-size: 12px !important }
    tbody tr:nth-of-type(2n) { background-color: #eceded !important; }
</style>